import { AxiosError, AxiosResponse } from "axios"
import api from "../../../data/api"
import { Dispatch } from "react"
import { prepareError, prepareErrorFromArray } from "../../../utils/error"
import { objectFormData } from "../../../utils/formdata"
import {SearchHistoryAction} from "../../../components/app/reducer"
import { Depository } from "../../../openapi/depository/api"
import { DepositoryAction } from "../results/reducer"
import { DepositoryCriteriaAction } from "./reducer"


// search for Depositories
export const fetchDepos = (
    dispatch: Dispatch<DepositoryAction|DepositoryCriteriaAction>,
    dispatchHistory: Dispatch<SearchHistoryAction>,
    data: FormData,
    depSearchHistory: Object
) => {
    dispatchHistory({type: "SearchHistory", searchHistory: depSearchHistory});
    api
        .post("/codelist/v1/Depository/search",  objectFormData(data)  ) 
        .then( (response:AxiosResponse) => {

            if ( response.data.result && response.data.result === "ERROR") {
                dispatch({ type: "Depository/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Error") })
            } else if ( response.data.result && response.data.result === "REJECTED" ){
                dispatch({ type: "Depository/FETCHERROR", payload: "For selected search criteria no data has been found." })
            } else { 
                 console.log("depo query service: got data " + JSON.stringify(response, null, 2))
                const depositories : Depository[] = response.data.Depository; 
                if ( depositories.length === 0 ) {
                    dispatch({ type: "DepositoryCriteria/FETCHERROR", payload: prepareErrorFromArray(["No Results Found"], "Error") })
                } else {
                    // console.log( "Ccb criteria service -> fetchCcb::dispatching " + JSON.stringify( ccbs, null, 2))
                    dispatch({type: "Depository/SEARCHDONE", payload: depositories, searchCriteria: data });
                    dispatch({ type: "Depository/FETCHERROR", payload: "" });                    
                }
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: "Depository/FETCHERROR", payload: prepareError(error) })
        })
}
